<template>
  <div class="comp-operation">
    <jw-modal class="operation-modal" :visible="visible" :title="title" @cancel="handleCancel" title-align="start" :footer="false" width="900px" :body-style="{ height: '600px' }" :mask-closable="false">
      <jw-form :form="data.form" ref="formRef" label-align="left" auto-label-width>
        <jw-row :gutter="24">
          <jw-col :span="8">
            <jw-form-item field="userIds" label="操作人" asterisk-position="end" label-col-flex="auto" class="form-label-text">
              <jw-select v-model="data.form.userIds" @change="personChange" :loading="data.loading" placeholder="请输入..." class="rule-form-item-sub-select" @search="search" :multiple="true" style="width: 200px" allow-search allow-clear>
                <jw-option v-for="item in data.list" :key="item.id" :title="item.userName || item.departmentName" :value="item.id">
                  <div style="">
                    <xl-avatar style="pointer-events: none" :avatar="{ name: item.userName || item.departmentName, url: item.avatarOrigin, id: item.id }" :size="22" />
                  </div>
                </jw-option>
              </jw-select>
            </jw-form-item>
          </jw-col>
          <jw-col :span="12">
            <jw-form-item field="dateRang" label="操作时间" asterisk-position="end" label-col-flex="auto">
              <jw-range-picker show-time format="YYYY-MM-DD HH:mm" v-model="data.form.dateRang" :time-picker-props="{ defaultValue: ['00:00:00', '23:59:59'] }" @change="dateChange" />
            </jw-form-item>
          </jw-col>
          <jw-col :span="4">
            <jw-button @click="resetForm">重置</jw-button>
          </jw-col>
        </jw-row>
      </jw-form>

      <fh-table :bordered="false" v-on="tPropsEvent" v-bind="tProps" :columns="columns" resizable uuid="operation_table">
        <!-- 操作人 -->
        <template #operatorUser="{ row }">
          <xl-avatar :avatar="{ name: row?.operatorUser?.userName || $t('系统'), url: row?.operatorUser?.avatarOrigin, id: row?.operatorUser?.userId }" />
        </template>
      </fh-table>
    </jw-modal>
  </div>
</template>

<script setup lang="jsx">
import { reactive, ref } from 'vue';
console.log('1-开始创建组件-setup');
import useFhTable from '@/hooks/fh-table';
import { publicService } from '@/api/';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { orgService } from '@/api';

const { t } = useI18n();

const { tProps, tPropsEvent, setLoadListParams, loadTList, setTProps } = useFhTable(publicService.getOperationLog.bind(publicService));
const data = reactive({
  instanceId: null,
  loading: false,
  list: [],
  form: {
    userIds: null,
    dateRang: []
  }
});
const name = ref();
const formRef = ref();
const visible = ref(false);
const title = ref('弹窗标题');
const filterValue = reactive({
  gmtCreated: ['2024-11-01', '2024-11-20'], // 创建时间
  createUser: []
});
console.log('1-开始创建组件-setup', filterValue);

const uniqueById = (arr) => {
  const uniqueMap = {};
  return arr.filter((obj) => {
    if (!uniqueMap[obj.id]) {
      uniqueMap[obj.id] = true;
      return true;
    }
    return false;
  });
};

// 搜索部门/人员
const getUserAndDeptByKeyWord = async (e) => {
  const params = {
    departmentId: '',
    all: false,
    keyWord: e || '',
    userSelector: true
  };
  data.loading = true;
  const json = await orgService.searchDepartUserList(params);
  if (!json.error) {
    data.list = (json.result?.userList || []).concat(data.list);
    data.list = uniqueById(data.list);
    console.log('搜索用户', data.list);
  }
  data.loading = false;
};

let timer;
const search = (e) => {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    if (e.trim()) getUserAndDeptByKeyWord(e);
  }, 500);
};

const columns = [
  {
    title: t('操作人'),
    colKey: 'operatorUser',
    slotName: 'operatorUser',
    width: 130
  },
  {
    title: t('操作详情'),
    colKey: 'operationDetails',
    width: 180
  },
  {
    title: t('备注'),
    colKey: 'mark',
    width: 180
  },
  {
    title: t('操作时间'),
    colKey: 'gmtCreated',
    width: 180
  }
];

const resetForm = () => {
  formRef.value.resetFields(); // todo 清空表单不生效
  data.form.dateRang = [];
  data.form.userIds = [];
  console.log('重置表单', formRef.value);
  getLoadList();
};

const getLoadList = () => {
  setLoadListParams({
    instanceId: data.instanceId,
    page: 1,
    pageSize: -1,
    userIds: data.form.userIds,
    startTime: data.form.dateRang[0],
    endTime: data.form.dateRang[1]
  });
  loadTList();
};

const handleCancel = () => {
  visible.value = false;
  console.log('handleCancel');
};

const personChange = (personVal) => {
  console.log('人员搜索', personVal);
  getLoadList();
};

const dateChange = (dateVal) => {
  console.log('日期搜索', dateVal);
  getLoadList();
};

const openModal = (record) => {
  (data.instanceId = record.instanceId),
    setLoadListParams({
      instanceId: data.instanceId,
      page: 1,
      pageSize: -1
    });
  visible.value = true;
  title.value = '操作记录';
  loadTList();
};
console.log(data, name);

onMounted(async () => {
  setTProps({
    stickyHeader: 60,
    pagination: false
  });
});

defineExpose({
  openModal
});
</script>
<style scoped lang="less">
@import './operation.less';
</style>
